export default __webpack_public_path__ + "static/media/EI2-2.5dc887f7.jpg";